<!-- <template>
  <v-main id="layout" class="fill-height">
    <v-container fluid fill-height class="pa-0">
      <router-view :key="$route.fullPath" />
    </v-container>
  </v-main>
</template> -->

<template>
  <v-main id="layout" class="pa-0">
    <router-view :key="$route.fullPath" />
  </v-main>
</template>

<script>
export default {
  name: 'FullLayout',
};
</script>
